module.exports = __webpack_public_path__ + "static/ayampe2-3839f400720ae4ddf5bf498ab4d30fa7.png";